import styles from "./Hero.module.css";

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section id="hero" className={styles.hero}>
      <div className={styles.glowTopRight} />
      <div className={styles.glowBottomLeft} />

      <div className={styles.content}>
        <div className={styles.badge}>Since 2002</div>

        <h1 className={styles.titleLight}>Ratnapura</h1>
        <h1 className={styles.titleBold}>Gems</h1>

        <div className={styles.divider} />

        <p className={styles.tagline}>Premium Sri Lankan Gems & Jewellery</p>

        <div className={styles.ctaGroup}>
          <button className={styles.btnPrimary} onClick={() => scrollTo("collection")}>
            Explore Collection
          </button>
          <a
            href="https://instagram.com/ratnapuragems"
            target="_blank"
            rel="noreferrer"
            className={styles.btnOutline}
          >
            Instagram
          </a>
        </div>

        <div className={styles.stats}>
          {[
            ["24+", "Years Trusted"],
            ["100%", "Handcrafted"],
            ["Free", "Island wide Delivery"],
          ].map(([num, label]) => (
            <div key={label} className={styles.stat}>
              <span className={styles.statNum}>{num}</span>
              <span className={styles.statLabel}>{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* <div className={styles.scrollIndicator}>
        <span className={styles.scrollText}>Scroll</span>
        <div className={styles.scrollLine} />
      </div> */}
    </section>
  );
}